<template>
  <v-row class="fill-height">
    <v-col>      
      <v-sheet   height="55">
        <v-toolbar class="flex-grow-0"
          dark
          color="indigo"
          shaped >
        <v-btn text small class="mr-5" oulined size="x-large"  @click="setToday" color="orange">Today</v-btn>          
          <v-btn fab text small
              color="orange-darken-2"
              @click="prev"
          >
            <v-icon small >  mdi-chevron-left </v-icon>
            
          </v-btn>

            <v-toolbar-title  
            
              v-if="$refs.hvscalendar">
              {{ $refs.hvscalendar.title }}
            </v-toolbar-title>

            <v-btn  fab  text  small  color="orange-darken-2"
              @click="next"
            >
              <v-icon small >  mdi-chevron-right   </v-icon>
            </v-btn>             

            <v-spacer></v-spacer>
            <v-menu  bottom right
            >
            <template v-slot:activator="{ on, attrs }">
              <v-btn  text small outlined color="orange"  v-bind="attrs" v-on="on"
              >
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Day</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Week</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Month</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = '4day'">
                <v-list-item-title>4 days</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="500">
        <div  class="ma-4" style="height: 100%" >
        <v-calendar
          ref="hvscalendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :type="type"          
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"          
          @change="updateEvent" 
        ></v-calendar>
        </div>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card
            color="grey lighten-4"
            min-width="350px"
            flat
          >
            <v-toolbar
              :color="selectedEvent.color"
              dark
            >
              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>              
              <!-- <v-spacer></v-spacer> -->
              <!-- <v-btn icon>
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn> -->
            </v-toolbar>
            <v-card-text>
              <span v-html="selectedEvent.name"></span>
            </v-card-text>
            <v-card-actions>
              <v-btn
                text
                color="orange"
                @click="selectedOpen = false"              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>    
    </v-col>
  </v-row>
</template>

<script>

import { getv20a2000 } from '@/api/view/pp/20/v20a2000.js' 

  export default {
    data: () => ({
      hvscalendar: 'hvscalendar',
      focus: '',
      type: 'month',
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
        '4day': '4 Days',
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: []
    }),
    mounted () {
      // console.log("hvscalendar", this.$refs.hvscalendar)
      this.$refs.hvscalendar.checkChange()
    },
    methods: {
      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = ''
      },

      prev () {
        this.$refs.hvscalendar.prev()
      },

      next () {
        this.$refs.hvscalendar.next()
      },

      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
        }

        
        if (this.selectedOpen) {
          this.selectedOpen = false
          requestAnimationFrame(() => requestAnimationFrame(() => open()))
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
     

      updateEvent ({ start}) {
        
        // console.log(start)
        this.doSearchEvent(start)

     },

     async doSearchEvent(start){

      const events = []      
      // this.openLoading('searching')
      
      let params = {
        month: start.date                 
      }      
      await getv20a2000(params).then(res => {
        
        let st = new Date()
        let ed = new Date()
        for (let i = 0; i < res.list.length; i++) {       

            st = new Date(res.list[i].stDte)  
            ed = new Date(res.list[i].edDte)
            
           events.push({
              name: res.list[i].evtDesc,
              start: st,
              end: ed,
              color: res.list[i].clor,
              timed: false
            })
           

        }    

        this.events = events
        
      }).finally(() => {
        // 
      })

    },  

      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
    },
  }
</script>